import {Component, EventEmitter, OnInit, Output, AfterViewInit, Input} from '@angular/core';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../classes/dynamicScripts';
import { APP_RECAPTCHA_KEY } from '../../app-config.constants';
import { HasSubscriptions } from '../has-subscriptions';

declare var grecaptcha: ReCaptchaV2.ReCaptcha;

@Component({
  selector: 'app-recaptcha',
  template: '<div [id]="uniqueId" class="recaptcha-container"></div>'
})
export class RecaptchaComponent extends HasSubscriptions implements OnInit, AfterViewInit {
  public static nextId = 0;

  @Output() recaptchaIdCreated = new EventEmitter<number>();
  @Input() onSubmit: (recaptchaToken: string) => void;

  readonly uniqueId: string;
  private _widgetId: number;

  constructor(
    private domManipulationService: DomManipulationService,
  ) {
    super();
    this.uniqueId = 'app-recaptcha-' + RecaptchaComponent.nextId;
    RecaptchaComponent.nextId++;
  }

  ngOnInit() {
    this.domManipulationService.loadScript(RECAPTCHA_SCRIPT);
  }

  ngAfterViewInit() {
    this.addSub(this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(() => {
      this._widgetId = grecaptcha.render(this.uniqueId, {
        badge: 'inline',
        sitekey: APP_RECAPTCHA_KEY,
        size: 'invisible',
        callback: this.resetAfterCallback.bind(this)
      });
      this.recaptchaIdCreated.emit(this._widgetId);
    }));
  }

  resetAfterCallback(recaptchaToken: string) {
    return new Promise((resolve, reject) => {
      if (!recaptchaToken) {
        reject();
      }
      this.onSubmit(recaptchaToken);
      grecaptcha.reset(this._widgetId);
      resolve();
    });
  }
}
